import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Nftnumbers() {
  return (
    <section className="nft_numbers p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Unlock Superior NFT Development with TekRevol</h2>
            <p>
              Enhance the efficiency and security of your digital assets with
              our value-driven NFT development services. We ensure seamless
              integration and exceptional performance of NFTs across all
              platforms.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="nft_numbers_main">
              <div className="nft_num_item">
                <div className="nft_item_content">
                  <h2>40%</h2>
                  <p>
                    Reduced
                    <br /> Development Time
                  </p>
                </div>
              </div>
              <div className="nft_num_item">
                <div className="nft_item_content">
                  <h2>55%</h2>
                  <p>
                    Increase in Asset
                    <br /> Security & Transparency
                  </p>
                </div>
              </div>
              <div className="nft_num_item">
                <div className="nft_item_content">
                  <h2>65%</h2>
                  <p>
                    Boost in User
                    <br /> Engagement
                  </p>
                </div>
              </div>
              <div className="nft_num_item">
                <div className="nft_item_content">
                  <h2>100%</h2>
                  <p>
                    Compliance with
                    <br /> Blockchain Standards
                  </p>
                </div>
              </div>
              <div className="nft_num_item">
                <div className="nft_item_content">
                  <h2>99%</h2>
                  <p>
                    Uptime for Reliable
                    <br /> NFT Transactions
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Discover More NFT Benefits
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nftnumbers;
